import ingredientsData from './shared/state';

export default {
  modules: {
    ingredientsData,
  },
};
